module.exports = __webpack_public_path__ + "img/blue6.d705d2ae.jpg";